import api from './api';

interface ChangePasswordResponse {
  message: string;
}

interface ForgotPasswordResponse {
  message: string;
}

interface ResetPasswordResponse {
  message: string;
}

interface SwitchTenantResponse {
  token: string;
  refreshToken: string;
  expiration: string;
  username: string;
  roles: string[];
  tenantId?: number;
  tenantCode?: string;
  tenantName?: string;
}

const authService = {
  switchTenant: async (tenantId: number): Promise<SwitchTenantResponse> => {
    const response = await api.post<SwitchTenantResponse>('/api/Auth/switchtenant', { tenantId });
    return response.data;
  },

  changePassword: async (currentPassword: string, newPassword: string): Promise<ChangePasswordResponse> => {
    const response = await api.post<ChangePasswordResponse>('/api/auth/changepassword', {
      currentPassword,
      newPassword
    });
    return response.data;
  },

  forgotPassword: async (username: string): Promise<ForgotPasswordResponse> => {
    const response = await api.post<ForgotPasswordResponse>('/api/auth/forgotpassword', {
      username
    });
    return response.data;
  },

  resetPassword: async (token: string, newPassword: string): Promise<ResetPasswordResponse> => {
    const response = await api.post<ResetPasswordResponse>('/api/auth/resetpassword', {
      token,
      newPassword
    });
    return response.data;
  }
};

export default authService;

